import { useIsMobile } from '../../../../../utils/getIsMobile';
import { useTranslation } from '../../../../../utils/useTranslation';
import { DialogTitle } from '../../../../feedback/Dialog';
import { Typography } from '../../../../typography/Typography';
import { ICreateCollectionDialogTitleProps } from './typings';

export const CreateCollectionDialogTitle: React.FC<ICreateCollectionDialogTitleProps> = ({
    onClose,
}) => {
    const t = useTranslation();
    const isMobile = useIsMobile();

    return (
        <DialogTitle
            onClose={onClose}
            withBorderBottom={false}
            px={isMobile ? 3 : 0}
            py={isMobile ? 2 : 1}
            closeRightOffset={isMobile ? { xs: 0, sm: 1 } : -1}
        >
            <Typography variant="title3" weight="bold">
                {t('Выберите посты')}
            </Typography>
        </DialogTitle>
    );
};
